import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const generateReportIndividualInsightsApi = ({ cohort, groupByKeys, orderBy, timeBounds = null }) => {
  const url = endpoints.rabbitGoals.generateReportIndividualInsights;

  const body = {
    cohort,
    groupByKeys,
    source: null,
    filter: null,
    orderBy,
    ...(timeBounds && { timeBounds }),
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const reportGenerationStatusIndividualInsightsApi = (requestIds) => {
  const url = endpoints.rabbitGoals.reportGenerationStatusIndividualInsights;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      requestIds,
    },
  });
};

export const getStatusOfIndividualInsightsReportGenerationRequests = async (validDownloadRequests) => {
  const queryParams = validDownloadRequests.map((request) => request.uuid);

  const response = await reportGenerationStatusIndividualInsightsApi(queryParams);
  return response.entity;
};

export const downloadReportIndividualInsightsApi = (requestId) => {
  const url = endpoints.rabbitGoals.downloadReportIndividualInsights(requestId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const generateReportObjectiveInsightsApi = ({ cohort, groupByKeys, orderBy, timeBounds = null }) => {
  const url = endpoints.rabbitGoals.generateReportObjectiveInsights;

  const body = {
    cohort,
    groupByKeys,
    source: null,
    filter: null,
    orderBy,
    ...(timeBounds && { timeBounds }),
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const reportGenerationStatusObjectiveInsightsApi = (requestIds) => {
  const url = endpoints.rabbitGoals.reportGenerationStatusObjectiveInsights;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      requestIds,
    },
  });
};

export const getStatusOfObjectiveInsightsReportGenerationRequests = async (validDownloadRequests) => {
  const queryParams = validDownloadRequests.map((request) => request.uuid);

  const response = await reportGenerationStatusObjectiveInsightsApi(queryParams);
  return response.entity;
};

export const downloadReportObjectiveInsightsApi = (requestId) => {
  const url = endpoints.rabbitGoals.downloadReportObjectiveInsights(requestId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};
